import { render, staticRenderFns } from "./Formulario020B.vue?vue&type=template&id=078c9dbc"
import script from "./Formulario020B.vue?vue&type=script&lang=js"
export * from "./Formulario020B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports